// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/v1/memory.proto (package infinigence.infini.agentplatform.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Param } from "./param_pb.js";
import { file_agentplatform_v1_param } from "./param_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/v1/memory.proto.
 */
export const file_agentplatform_v1_memory: GenFile = /*@__PURE__*/
  fileDesc("Ch1hZ2VudHBsYXRmb3JtL3YxL21lbW9yeS5wcm90bxIjaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEi2wMKBk1lbW9yeRIKCgJpZBgBIAEoCRIMCgRuYW1lGAMgASgJEhMKC2Rlc2NyaXB0aW9uGAQgASgJEhwKCXRlbmFudF9pZBgFIAEoCVIJdGVuYW50X2lkEhgKB3VzZXJfaWQYBiABKAlSB3VzZXJfaWQSGgoIY2xhc3NfaWQYByABKAlSCGNsYXNzX2lkEmAKDGNsYXNzX3BhcmFtcxgIIAMoCzI8LmluZmluaWdlbmNlLmluZmluaS5hZ2VudHBsYXRmb3JtLnYxLk1lbW9yeS5DbGFzc1BhcmFtc0VudHJ5UgxjbGFzc19wYXJhbXMSHgoKY3JlYXRlZF9hdBgJIAEoA1IKY3JlYXRlZF9hdBIeCgp1cGRhdGVkX2F0GAogASgDUgp1cGRhdGVkX2F0Eh4KCmRlbGV0ZWRfYXQYCyABKANSCmRlbGV0ZWRfYXQSEAoIcHJvdmlkZXIYDCABKAkSGgoIc3RvcmVfaWQYDSABKAlSCHN0b3JlX2lkEioKEGludGVyYWN0aW9uX21vZGUYDiABKAlSEGludGVyYWN0aW9uX21vZGUaMgoQQ2xhc3NQYXJhbXNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBIs8CCgtNZW1vcnlDbGFzcxIKCgJpZBgBIAEoCRIMCgRuYW1lGAMgASgJEhMKC2Rlc2NyaXB0aW9uGAQgASgJEhwKCXRlbmFudF9pZBgFIAEoCVIJdGVuYW50X2lkEhgKB3VzZXJfaWQYBiABKAlSB3VzZXJfaWQSPQoIdGVtcGxhdGUYCiABKAsyKy5pbmZpbmlnZW5jZS5pbmZpbmkuYWdlbnRwbGF0Zm9ybS52MS5NZW1vcnkSOgoGcGFyYW1zGAsgAygLMiouaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjEuUGFyYW0SHgoKY3JlYXRlZF9hdBgMIAEoA1IKY3JlYXRlZF9hdBIeCgp1cGRhdGVkX2F0GA0gASgDUgp1cGRhdGVkX2F0Eh4KCmRlbGV0ZWRfYXQYDiABKANSCmRlbGV0ZWRfYXRCSVpHZ2l0bGFiLmluZmluaS1haS5jb20vbWl6YXIvaW5maW5pYWktYWdlbnRpYy1pbmZyYS9jb21tb24vZ3JwY2FwaXMvdjE7djFiBnByb3RvMw", [file_agentplatform_v1_param]);

/**
 * 定义记忆
 *
 * @generated from message infinigence.infini.agentplatform.v1.Memory
 */
export type Memory = Message<"infinigence.infini.agentplatform.v1.Memory"> & {
  /**
   * 资源编号
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 记忆名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 记忆描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * 租户 ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 5 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 用户 ID
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 6 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 所属记忆类 ID
   * @gotags: json:"class_id,omitempty"
   *
   * @generated from field: string class_id = 7 [json_name = "class_id"];
   */
  classId: string;

  /**
   * 使用记忆类创建记忆时传入的参数列表
   * @gotags: json:"class_params,omitempty"
   *
   * @generated from field: map<string, string> class_params = 8 [json_name = "class_params"];
   */
  classParams: { [key: string]: string };

  /**
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 9 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 10 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 11 [json_name = "deleted_at"];
   */
  deletedAt: bigint;

  /**
   * 记忆服务提供者
   * @gotags: json:"provider,omitempty"
   *
   * @generated from field: string provider = 12;
   */
  provider: string;

  /**
   * Store ID
   * @gotags: json:"store_id,omitempty"
   *
   * @generated from field: string store_id = 13 [json_name = "store_id"];
   */
  storeId: string;

  /**
   * 记忆交互模式: AUTO_EXTRACT_AND_INSERT, TOOL, AUTO_EXTRACT_AND_TOOL
   * @gotags: json:"interaction_mode,omitempty"
   *
   * @generated from field: string interaction_mode = 14 [json_name = "interaction_mode"];
   */
  interactionMode: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.Memory.
 * Use `create(MemorySchema)` to create a new message.
 */
export const MemorySchema: GenMessage<Memory> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_memory, 0);

/**
 * 定义记忆类
 *
 * @generated from message infinigence.infini.agentplatform.v1.MemoryClass
 */
export type MemoryClass = Message<"infinigence.infini.agentplatform.v1.MemoryClass"> & {
  /**
   * 资源编号
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 记忆类名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 记忆类描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * 租户 ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 5 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 用户 ID
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 6 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 记忆 Template
   * @gotags: json:"template,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Memory template = 10;
   */
  template?: Memory | undefined;

  /**
   * 记忆类参数
   * @gotags: json:"params,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.Param params = 11;
   */
  params: Param[];

  /**
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 12 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 13 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 14 [json_name = "deleted_at"];
   */
  deletedAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.MemoryClass.
 * Use `create(MemoryClassSchema)` to create a new message.
 */
export const MemoryClassSchema: GenMessage<MemoryClass> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_memory, 1);

